/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '../../Modal'

interface FsiPropertiesConfirmModalProps {
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Confirmation modal shown when user tries to cancel/close properties modal with unsaved changes
 * Matches legacy FsiPropertiesConfirmScreenModal behavior
 */
export const FsiPropertiesConfirmModal: FC<FsiPropertiesConfirmModalProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation()

  return (
    <Modal show handleClose={onCancel} title={t('PROPERTIES_LEAVE_SCREEN_TITLE')} size="md">
      <Modal.Body>
        <p>{t('PROPERTIES_LEAVE_SCREEN_BODY')}</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link" onClick={onConfirm}>
          {t('LEAVE')}
        </button>
        <button className="btn btn-primary" onClick={onCancel}>
          {t('STAY')}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default FsiPropertiesConfirmModal
